jQuery(function ($) {
	$(document).foundation();
});

